import { HtmlPage } from "htmlpage/types/html-page.model";
import { Stack } from "@mantine/core";
import { Footer } from "event/play/components/Footer";
import { EventHeader } from "event/play/components/EventHeader";

//props

interface PlayHtmlPageViewProps {
  htmlPage: HtmlPage;
  playerId: string;
  partitionId: string;
  playerInfo: any;
}

export const PlayHtmlPageView: React.FC<PlayHtmlPageViewProps> = ({
  htmlPage,
  playerId,
  partitionId,
  playerInfo,
}) => {
  return (
    <>
      <Stack
        className="min-h-screen justify-start"
        justify="center"
        align={"center"}
      >
        <EventHeader />
        <div
          dangerouslySetInnerHTML={{
            __html: htmlPage.content || "No Content Found",
          }}
        />
      </Stack>
      <Footer />
    </>
  );
};

export default PlayHtmlPageView;
